import { HelpMessage } from 'utils/constants'
import UserTags from 'components/CIMSTags/common/UserTags'
import { UserTagUser } from 'components/CIMSTags/common/UserTags/types'
import { useDSNotificationsContext } from '../../DSNotificationsContext'
import { ApproverTagsProps } from './types'
import CIMSSection from 'components/CIMSSection'

const ApproverTags: React.VFC<ApproverTagsProps> = ({ discipline }) => {
  const { data } = useDSNotificationsContext()
  const users = discipline
    ? data?.dsDisciplines.find(({ id }) => id === discipline.id)?.users ?? []
    : data?.dsDisciplines?.flatMap(({ users }) => users) ?? []
  const uniqueUsers = [...new Set(users.map((u) => JSON.stringify(u)))].map(
    (s) => JSON.parse(s) as UserTagUser
  )
  if (!uniqueUsers.length) return null
  return (
    <CIMSSection
      title="Approvers"
      help={HelpMessage.DesignSubmittals.Notifications.Approvers(discipline)}
    >
      <UserTags users={uniqueUsers} />
    </CIMSSection>
  )
}

export default ApproverTags
